import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';

@Component({
    selector: 'switch-field',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SwitchComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => SwitchComponent), multi: true}
    ]
})
export class SwitchComponent extends AbstractFieldClass {
    @Input() isActive: boolean = false;
    @Input() title: string = '';
    @Input() disabled: boolean = false;

    public validator(value): boolean {
        return true;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/fields/switch/switch.component.ts